import { adminApi } from "../../../api/adminClient";
import { cloneFormData, unwrapList, unwrapOne } from "../utils/adminApiHelpers";

export { unwrapList, unwrapOne };

function appendFields(fd, data) {
  fd.append("title_ar", String(data.title_ar ?? "").trim());
  fd.append("title_en", String(data.title_en ?? "").trim());
  fd.append("description_ar", String(data.description_ar ?? "").trim());
  fd.append("description_en", String(data.description_en ?? "").trim());
  const list = data.image;
  const file =
    list && typeof list.length === "number" && list.length > 0
      ? list[0]
      : null;
  if (file instanceof File && file.size > 0) {
    fd.append("image", file);
  }
}

export function buildReferenceFormData(data) {
  const fd = new FormData();
  appendFields(fd, data);
  return fd;
}

export function buildReferenceFormDataForUpdate(data) {
  const fd = buildReferenceFormData(data);
  fd.append("title[ar]", String(data.title_ar ?? "").trim());
  fd.append("title[en]", String(data.title_en ?? "").trim());
  fd.append("description[ar]", String(data.description_ar ?? "").trim());
  fd.append("description[en]", String(data.description_en ?? "").trim());
  return fd;
}

export const fetchReferenceList = () => adminApi.get("/references");

export const fetchReferenceById = (id) =>
  adminApi.get(`/admin/references/${id}`);

export const createReference = (formData) =>
  adminApi.post("/admin/references", formData);

export const updateReference = (id, formData) => {
  const fd = cloneFormData(formData);
  fd.append("_method", "PUT");
  return adminApi.post(`/admin/references/${id}`, fd);
};

export const deleteReference = (id) =>
  adminApi.delete(`/admin/references/${id}`);
